import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WebhookForm = _resolveComponent("WebhookForm")!

  return (_openBlock(), _createBlock(_component_WebhookForm, {
    id: _ctx.id,
    initial: _ctx.effectiveInitial,
    "visibility-config": _ctx.visibilityConfig,
    onSaved: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('saved')))
  }, null, 8, ["id", "initial", "visibility-config"]))
}